export default "/images/msa-logo-blue.png?cbc0f685966404ffe7cde4d0c8b9cb94";